import {ENV} from "./env";

export const URL = {
  V3_API: process.env.REACT_APP_V3_API,
  REDBRICK_LAND: process.env.REACT_APP_REDBRICK_LAND,
  CHAT_SOCKET_SERVER: process.env.REACT_APP_CHAT_SOCKET_SERVER,
  STUDIO: process.env.REACT_APP_STUDIO,
  WIKI: process.env.REACT_APP_WIKI,
  DISCORD: "http://discord.gg/redbrick-create",
  SSAFY9_DISCORD: "https://discord.gg/kYRhthyV",
  S3_WORLD_STORAGE: process.env.REACT_APP_S3_WORLD_STORAGE,
  S3_PROJECT_STORAGE: process.env.REACT_APP_S3_PROJECT_STORAGE,
  S3_PROJECT_TEMPLATE_STORAGE: process.env.REACT_APP_S3_PROJECT_TEMPLATE_STORAGE,
  S3_ASSET_STORE: process.env.REACT_APP_S3_ASSET_STORE,
  S3_ASSET_STORE_BUCKET_NAME: process.env.REACT_APP_S3_NAME,
  S3_FONT: process.env.REACT_APP_S3_FONT,
  S3_ASSET_ETC: "https://store.redbrick.land/common",
  REDBRICK_STORE: "https://store.redbrick.land/",
  COLYSEUS: process.env.REACT_APP_COLYSEUS,
  IPX_DISCORD: "https://discord.com/invite/dpJpCX85hp",
  MANPLUS_AD: "https://mtag.mman.kr/get_ad.mezzo/?e_version=2&a_publisher=1677&a_media=32801&i_response_format=json&d_used_type=api",
  STUDIO_REDBRICK_VIDEO: "https://wizschool-etc.s3.ap-northeast-2.amazonaws.com/banner_video_redbrick.mp4",
  STUDIO_DONGYANG_VIDEO: "https://wizschool-etc.s3.ap-northeast-2.amazonaws.com/banner_video_dongyang.mp4",
  STUDIO_MALAYSIA_VIDEO: "https://wizschool-etc.s3.ap-northeast-2.amazonaws.com/banner_video_malaysia.mp4",
  CHATBOT_SERVER: process.env.REACT_APP_CHAT_CHATBOT_SERVER,
};

export const METHOD = {
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
  PATCH: "PATCH",
  DELETE: "DELETE",
};

export const OBJECT_CATEGORY = {
  MESH: "MESH",
  CAMERA: "CAMERA",
  LIGHT: "LIGHT",
  EFFECT: "EFFECT",
  STARTLOCATION: "STARTLOCATION",
  VIDEO: "VIDEO",
  IMAGE: "IMAGE",
  DEMO: "DEMO",
  GUI: "GUI",
  AUDIO: "AUDIO",
  PORTAL: "PORTAL",
  AD_BANNER: "AD_BANNER",
};

export const MESH = {
  CUBE: "CUBE", //code for old library. need to remove later
  SQUARE: "SQUARE", //code for old library. need to remove later
  CIRCLE: "CIRCLE",
  CYLINDER: "CYLINDER",
  CAPSULE: "CAPSULE",
  SPHERE: "SPHERE",
  CONE: "CONE",
  TORUS: "TORUS",
  DODECAHEDRON: "DODECAHEDRON",
  ICOSAHEDRON: "ICOSAHEDRON",
  LATHE: "LATHE",
  OCTAHEDRON: "OCTAHEDRON",
  PLANE: "PLANE",
  RING: "RING",
  SPRITE: "SPRITE",
  TETRAHEDRON: "TETRAHEDRON",
  TORUSKNOT: "TORUSKNOT",
  TUBE: "TUBE",
  BOX: "BOX",
};

export const LIGHT = {
  POINT: "POINT",
  DIRECTIONAL: "DIRECTIONAL",
  SPOT: "SPOT",
  HEMISPHERE: "HEMISPHERE",
  AMBIENT: "AMBIENT",
};

export const CAMERA = {
  PERSPECTIVE: "PERSPECTIVE",
  ORTHOGRAPHIC: "ORTHOGRAPHIC",
};

export const SELFIE = {
  SELFIE_ON: "SELFIE_ON",
  SELFIE_OFF: "SELFIE_OFF",
  NORMAL_MODE: "NORMAL_MODE",
  SELFIE_MODE: "SELFIE_MODE",
  TAKE_SELFIE: "TAKE_SELFIE",
  STOP_RECORD: "STOP_RECORD",
  PICTURE: "PICTURE",
  VIDEO: "VIDEO",
  HIDE_AVATARS: "HIDE_AVATARS",
  CLOSE_SAVE: "CLOSE_SAVE",
  SWITCH_HAND: "SWITCH_HAND",
};

export const ANIMATION_BAR = {
  PLAY: "PLAY",
};

export const ACTION_TYPE = {
  // locale
  SET_LOCALE: "SET_LOCALE",

  // codeEditor
  SET_CODE_EDITOR: "SET_CODE_EDITOR",
  SET_CODE_EDITOR_MODE: "SET_CODE_EDITOR_MODE",
  SET_CURRENT_SCRIPT: "SET_CURRENT_SCRIPT",
  SHOW_SCRIPT_LIST: "SHOW_SCRIPT_LIST",

  // dialog
  OPEN_DIALOG: "OPEN_DIALOG",
  CLOSE_DIALOG: "CLOSE_DIALOG",
  TOGGLE_DIALOG: "TOGGLE_DIALOG",

  // asset
  ADD_MESH: "ADD_MESH",
  // DELETE_MESH: "DELETE_MESH",
  // CHANGE_MESH: "CHANGE_MESH",

  ADD_OBJECT: "ADD_OBJECT",
  DELETE_OBJECT: "DELETE_OBJECT",
  COPY_OBJECT: "COPY_OBJECT",

  ADD_GUI: "ADD_GUI",
  DELETE_GUI: "DELETE_GUI",

  ADD_AD_BANNER: "ADD_AD_BANNER",

  ADD_AUDIO: "ADD_AUDIO",
  // DELETE_AUDIO: "DELETE_AUDIO",

  ADD_SCENE: "ADD_SCENE",
  DELETE_SCENE: "DELETE_SCENE",
  SELECT_SCENE: "SELECT_SCENE",
  SCENE_LOADED: "SCENE_LOADED",

  CHANGE_PROPERTY: "CHANGE_PROPERTY",
  CHANGE_PROPERTY_FROM_SCENE: "CHANGE_PROPERTY_FROM_SCENE",
  SELECT_MODE: "SELECT_MODE",
  SELECT_OBJECT: "SELECT_OBJECT",
  UNSELECT_OBJECT: "UNSELECT_OBJECT",
  PREVIEW_CAMERA: "PREVIEW_CAMERA",

  SET_OBJECT: "SET_OBJECT",
  OBJECT_ADDED: "OBJECT_ADDED",

  CONCEAL_OBJECT: "CONCEAL_OBJECT",
  REVEAL_OBJECT: "REVEAL_OBJECT",

  // // camera
  ADD_CAMERA: "ADD_CAMERA",

  // // light
  // ADD_LIGHT: "ADD_LIGHT",

  // layer
  SELECT_LAYER_TAB: "SELECT_LAYER_TAB",
  TOGGLE_HELPER: "TOGGLE_HELPER",
  TOGGLE_GRID: "TOGGLE_GRID",
  REORDER_OBJECT: "REORDER_OBJECT",

  // script
  CHANGE_SCRIPT: "CHANGE_SCRIPT",

  // Files
  SAVE_FILE: "SAVE_FILE",
  LOAD_FILE: "LOAD_FILE",
  UPLOAD_FILE: "UPLOAD_FILE",
  SAVE_PROJECT: "SAVE_PROJECT",
  LOAD_GLB: "LOAD_GLB",
  EXPORT_GLB: "EXPORT_GLB",

  LOAD_FROM_PID: "LOAD_FROM_PID",

  // util
  UPDATE_USERINFO: "UPDATE_USERINFO",
  LOGOUT: "LOGOUT",
  LOGIN: "LOGIN",

  // undo redo
  UNDO: "UNDO",
  REDO: "REDO",
  TOGGLE_UNDO_ABLE: "TOGGLE_UNDO_ABLE",
  TOGGLE_REDO_ABLE: "TOGGLE_REDO_ABLE",
  CHANGE_PROGRESS: "CHANGE_PROGRESS",

  // chat
  EDIT_ROOM: "EDIT_ROOM",
  ADD_CHAT_LIST: "ADD_CHAT_LIST",
  EDIT_CHAT_MODE: "EDIT_CHAT_MODE",
  SET_CHAT_ALERT: "SET_CHAT_ALERT",

  // voice_chat
  SET_DISTURB_MODE: "SET_DISTURB_MODE",

  // library
  SET_LIBRARY_ORIGIN: "SET_LIBRARY_ORIGIN",

  // audio player
  PLAY_AUDIO_PLAYER: "PLAY_AUDIO_PLAYER",
  STOP_AUDIO_PLAYER: "STOP_AUDIO_PLAYER",

  // play option
  CHANGE_PLAY_OPTION: "CHANGE_PLAY_OPTION",

  // alert popup
  OPEN_ALERT: "OPEN_ALERT",
  CLOSE_ALERT: "CLOSE_ALERT",

  // Avatar
  UPDATE_AVATARINFO: "UPDATE_AVATARINFO",

  // game
  SET_GAME_STATE: "SET_GAME_STATE",
  SEND_GAME_MESSAGE: "SEND_GAME_MESSAGE",
  RECEIVE_GAME_MESSAGE: "RECEIVE_GAME_MESSAGE",

  // asset
  HANDLE_ASSET_LIBRARY: "HANDLE_ASSET_LIBRARY",
  HANDLE_ASSET_LIBRARY_OPEN: "HANDLE_ASSET_LIBRARY_OPEN",
  SET_CURRENT_SEARCH_PARAMS: "SET_CURRENT_SEARCH_PARAMS",

  //auto save
  TOGGLE_AUTO_SAVE: "TOGGLE_AUTO_SAVE",

  // render info
  SCENE_INFO: "SCENE_INFO",

  // template
  GET_TEMPLATES: "GET_TEMPLATES",

  // ad
  CHANGE_AD_USED_STATE: "CHANGE_AD_USED_STATE",
  CHANGE_AD_SHOW_STATE: "CHANGE_AD_SHOW_STATE",
  CHANGE_AD_POSITION: "CHANGE_AD_POSITION",

  // sns login
  UPDATE_SNS_INFO: "UPDATE_SNS_INFO",

  // side panel
  CHANGE_SIDE_PANEL: "CHANGE_SIDE_PANEL",

  // tutorial
  TUTORIAL_MISSION_SUCCESS: "TUTORIAL_MISSION_SUCCESS",
  TUTORIAL_MISSION_FAIL: "TUTORIAL_MISSION_FAIL",
  // version
  UPDATE_VERSION_INFO: "UPDATE_VERSION_INFO",

  // property panel
  TOGGLE_COMPONENT: "TOGGLE_COMPONENT",
  CHANGE_CURRENT_PROPERTY_TAB: "CHANGE_CURRENT_PROPERTY_TAB",
};

export const GAME_STATE = {
  LOADING: "LOADING",
  LOADED: "LOADED",
  PAUSED: "PAUSED",
  PLAYING: "PLAYING",
  ENDED: "ENDED",
  CHAT_MODE: "CHAT_MODE",
};

export const MODE_TYPE = {
  CHANGE_MODE: "CHANGE_MODE",
  CHANGE_PUBLISH_MODE: "CHANGE_PUBLISH_MODE",
  EDIT_MODE: "edit",
  PLAY_MODE: "play",
  SINGLEPLAY_MODE: "SINGLE_PLAY_MODE",
  MULTIPLAY_MODE: "MULTI_PLAY_MODE",
};

export const TUTORIAL = {
  INIT_TUTORIAL: "INIT_TUTORIAL",
  HANDLE_TUTORIAL_PANEL: "HANDLE_TUTORIAL_PANEL",
  HANDLE_TUTORIAL_LIST: "HANDLE_TUTORIAL_LIST",
  HANDLE_TUTORIAL_MISSION: "HANDLE_TUTORIAL_MISSION",
  HANDLE_TUTORIAL_COMPLETED_MISSION_IDX: "HANDLE_TUTORIAL_COMPLETED_MISSION_IDX",
  GET_MY_PROJECT_INFO: "GET_MY_PROJECT_INFO",
};

export const TRANSFORM_TYPE = {
  CHANGE_TRANSFORM: "CHANGE_TRANSFORM",
  SNAP_ON: "SNAP_ON",
  SNAP_OFF: "SNAP_OFF",
  SET_SNAP_PROPERTY: "SET_SNAP_PROPERTY",
  SELECT: "select",
  TRANSLATE: "translate",
  ROTATE: "rotate",
  SCALE: "scale",
  MULTI: "multi",
};

export const AVATAR_ANIMATION = {
  IDLE: "IDLE",
  JUMP: "JUMP",
  FALL: "FALL",
  LAND: "LAND",
  SIT: "SIT",
  GROUND_SIT: "GROUND_SIT",
  WALK: "WALK",
  RUN: "RUN",
  BOOST: "BOOST",
  ATTACK: "ATTACK",
  DIE: "DIE",
  VICTORY: "VICTORY",
  SELFIE: "SELFIE",
  PICK: "PICK",
  DESSERT_EAT: "DESSERT_EAT",
  DESSERT_SMELL: "DESSERT_SMELL",
  HALLOWEEN_BASKET: "HALLOWEEN_BASKET",
  HALLOWEEN_CANDY: "HALLOWEEN_CANDY",
  HALLOWEEN_SCARE: "HALLOWEEN_SCARE",
  HI: "HI",
  LOSE: "LOSE",
  WIN: "WIN",
  WOAH: "WOAH",
  WOO: "WOO",
  THUMBS_UP: "THUMBS_UP",
};

export const PHYSICS_SHAPE = {
  BOX: "box",
  COMPOUND: "compound",
  HULL: "hull",
  HACD: "hacd",
  CONVEXMESH: "convexMesh",
  CONCAVEMESH: "concaveMesh",
};

export const WizSpritePrefix = "___m___";

export const EDITORMODE = {
  JAVASCRIPT: "javascript-wiz",
  JAVASCRIPT_3D: "javascript-wiz-3d",
  PYTHON: "python",
  BLOCK: "block",
};

export const AWS_INFO = {
  S3_ASSETS_URL: "https://wizschool-assets.s3.ap-northeast-2.amazonaws.com",
};

export const ADMIN_ACCOUNTS = ["redbrick.official@redbrick.space", "rei@redbrick.space", "tim@redbrick.space"];

export const CHAT_ONE_LINE_CHAR_LIMIT = 16;

export const CHAT_TYPE = {
  MESSAGE: "message",
  PRIVATE_MESSAGE: "private-message",
  WORLD_MESSAGE: "world-message",
  QUICK_MESSAGE: "quick-message",
  INVALIDATE: "invalidate",
};

export const WORLD_CHAT_COLOR = [
  "#E9226A",
  "#FF8A00",
  "#8566FF",
  "#0066FF",
  "#00D6AF",
  "#FF4F8E",
  "#FFE600",
  "#FF3FD5",
  "#61BDFF",
  "#CCFF00",
];

export const PLAY_MODE_ACTION = {
  SOUND: "sound",
  CHAT: "chat",
  VOICE_CHAT: "voice_chat",
  QUICK_CHAT: "quick_chat",
  SELFIE: "selfie",
  ANIMATION: "animation",
};

export const BREAK_POINT = {
  TABLET: "667",
  PC: "1180",
};

export const DEVICE = {
  TABLET: "TABLET",
  PC: "PC",
  MOBILE: "MOBILE",
};

export const SELFIE_CAM_WIDTH = {
  [DEVICE.MOBILE]: 220,
  [DEVICE.TABLET]: 320,
  [DEVICE.PC]: 550,
};

export const SELFIE_CAM_HEIGHT = {
  [DEVICE.MOBILE]: 50,
  [DEVICE.TABLET]: 150,
  [DEVICE.PC]: 150,
};

export const HOST = process.env.REACT_APP_HOST;
export const IS_DEV = HOST === ENV.DEV;

export const PRIVATE_CHAT_LIST = ["FOLLOWER", "FOLLOWING", "WORLD", "SEARCH"];

export const VOICE_CHAT_TYPE = ["WORLD", "PRIVATE", "NONE"];

export const PID = {
  NONSTOPCLE: "ca69c028-4b45-5851-a03f-9f8de710eb86",
  DONGYANGUNI: "48e77a71-8088-4970-9e3d-a4b0672ad663",
  MALAYASIA: "dd362c3e-caae-44c9-a0ba-4b17b6b7d0a1",
};

export const IPX_PID = {
  DONUT_DRIVE: "56309943-c849-4dad-8e21-4353862cc900",
  RUNNERZ: "4b76800f-1d1e-42fd-b440-5f9d1eb7f178",
  NEWYORK: "59e9b569-5a4e-420b-b666-31c73990bdf3",

  DEV_DONUT_DRIVE: "3523355b-b3cd-4800-9c48-e8a3320aa2e4",
  DONUT_DRIVE_TEST: "70dd9020-a64c-46d3-8ece-5b31ccc98e02",
  // DEV_RUNNERZ: "4b76800f-1d1e-42fd-b440-5f9d1eb7f178",
};

export const REDBRICK_EVENT_PID = {
  JUMP_SCENE_1: "ca826e8b-692c-4642-8e8f-c1480fe9191d",
  JUMP_SCENE_2: "28d4c47d-2c40-4552-8d5e-a0799287c9dd",
  JUMP_SCENE_3: "9e8129e8-b389-4872-8d8c-793434b8b521",
  FOREST_PARCOURS: "ef72cb17-5bb0-4b74-b002-8c7c4b45fb83",
  MAZE_CASTLE: "13e655ea-f393-463b-8ec8-a849f0512747",
  DREAM_ESCAPE: "247a120a-4596-4259-b22d-6f783895844b",

  DONUT_DRIVE: "a30b84d1-dfb4-442d-b55f-70626ea8cccb",
  RUNNERZ: "ec18ac4b-37c2-49e6-b934-9c82d718e125",

  TECHLYMPIC_LOBBY: "5eabe9e0-f2f2-4a4d-868b-332a76eaa591",
  TECHLYMPIC_AUDITORIUM: "063a1783-2e6f-4dd8-9eda-1447d9114eb0",
  TECHLYMPIC_MOSTI: "0f282e17-a614-4d33-a39a-2649660faab6",
  TECHLYMPIC_HALLOFFAME: "b2d32727-d7ab-4508-94c3-84499a68b21f",
  TECHLYMPIC_SPONSER: "81fa03bc-1b85-4aee-ae46-8d071377deda",
  TECHLYMPIC_CLASS: "c6fb752d-4fcf-4883-af73-5b81562e7b83",

  TECHLYMPIC_LOBBY_DEV: "0bb38969-e5b1-449c-84e3-b9005afb6290",

  RUNNERZ_2024_DEV: "277770e8-23e3-4608-bc01-6f95de593ced",
  RUNNERZ_2024: "7ac25198-bf45-41ae-8d5b-c244bf181d35",

  DIGITECH_LOBBY: "0edc0f24-bd86-4b4f-bfc8-ff42d9f97ec6",
  DIGITECH_AREANA: "db2408cd-1bd8-4f1c-9e3e-82e08d72b9f1",
  DIGITECH_AUDITORIUM: "671ca3c7-6328-4bf1-aa35-299ef6d36cef",
  DIGITECH_CAMPUS: "f2212cd4-822b-40ae-8962-b5bf49f8f9ca",
  DIGITECH_CREATIVELAB: "70a58fab-7fe6-4616-b64e-a99db825bf95",
  DIGITECH_GALLERY: "ecb8a1af-66c8-4481-94db-b98cc8df22e6",
};

export const WORLD_DEFAULT_ICON = "https://store.redbrick.land/etc/Choux/default_thumbnail.jpg";

export const LIB_SET_LIST = {
  BUILDING: "Building",
  NATURE: "Nature",
  STRUCTURE: "Structure",
  GROUND: "Ground",
  MACHINE: "Machine",
  FURNITURE: "Furniture",
  FOODS: "Foods",
  DECORATION: "Decoration",
  VEHICLE: "Vehicle",
};

export const GSTAR_UGC_PID_LIST = [
  "6f1e7fe5-8b87-4aeb-9dcd-96cc7296bd2a",
  "81e0f423-2d1a-4c53-915a-b76a508976ea",
  "4df37a50-079e-4549-8e9f-9d9312fc6a7b",
  "4c63cde2-802b-4c8b-8a6f-eb61c53b50ae",
  "955d5176-7db6-4eae-85e0-b881221e4146",
  "138dc5e2-56d3-461f-8476-9f9c3c1716ae",
  "43d7a593-9c08-4fe8-be3d-cd9a96febb6a",
  "f54adb7e-31d3-4663-a2bf-7a22c86ccf10",
  "771bc212-b913-484e-a78d-68d5322929cc",
  "ebd31128-a62f-478e-9f82-6a3ac66a5cd0",
  "7defa728-f532-4dc8-9e6f-c3114a66ce7e",
  "77bfb1da-8c08-482f-99ad-ea862da10400",
  "ac600574-625c-4c3d-bb4e-ad885c542357",
  "5b4c1ad5-efb7-44ba-9576-f5d42a335230",
  "317c3de7-41d5-43ae-83bf-8cf7da3e43c0",
  "20662b1b-6a0a-47d4-98a9-a55da6587e17",
  "1ce655c7-0607-4ce5-9152-3260bbc8c10f",
  "ef72cb17-5bb0-4b74-b002-8c7c4b45fb83",
  "247a120a-4596-4259-b22d-6f783895844b",
  "9f8c0e61-bc10-4d62-9be7-07242149894b",
  "13e655ea-f393-463b-8ec8-a849f0512747",
  "09790d6a-9bab-4253-8455-0ab412d64f20",
  "5b3095cf-7cb6-49e4-8d67-551002439052",
  "c90f4f00-c421-43b3-99e4-37a3d882fd7e",
  "ade7bd37-f918-4543-8810-a5a4fc466f43",
  "47174c25-e363-406c-92bc-fce8aeb293ad",
];

export const GOOGLE_SHEET = {
  ID_CONTENTS_LIST: process.env.REACT_APP_GOOGLE_SHEET_MAIN_CONTENTS_LIST_ID,
  VIDEO_AD: "videoAd",
};

export const PROPERTY_TAB = {
  OBJECT: "Object",
  SCENE: "Scene",
};

export const AUTO_SAVE_TIME = {
  time: 300000,
};

export * from "./account";
export * from "./assets";
export * from "./env";
export * from "./queryKeys";
export * from "./project";
export * from "./ipx";
export * from "./ssafy";
export * from "./class";
export * from "./ad";
export * from "./signIn";
export * from "./locale";
